/* globals moment */

class Inactivity {

  /**
   * The Inactivity constructor.
   *
   * @param duration
   * @returns {Promise}
   */
  constructor(duration, interval = 1000) {
    this.duration = duration;
    this.interval = interval;
    this.timeout = '';
    this.setTimeout();
    this.initListeners();

    return this.start();
  }

  /**
   * Construct a new Inactivity.
   *
   * @param duration
   * @returns {Inactivity}
   */
  static wait(duration) {
    return new Inactivity(duration);
  }

  /**
   * Start the Inactivity check.
   *
   * @returns {Promise}
   */
  start() {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (moment().isAfter(this.timeout)) {
          clearInterval(interval);
          resolve();
        }
      }, this.interval);
    });
  }

  /**
   * Set the timeout.
   */
  setTimeout() {
    this.timeout = moment().add(...this.duration.split(' '));
  }

  /**
   * Init the events listeners.
   */
  initListeners() {
    document.addEventListener('click', this.setTimeout.bind(this));
    document.addEventListener('keydown', this.setTimeout.bind(this));
  }

}

export default Inactivity;
